"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class FailedToDecryptConnectionKeyError extends client_library_1.ExtendableError {
    constructor(connectionKey) {
        super(`Failed to decrypt connection key: ${connectionKey}`);
        this.connectionKey = connectionKey;
    }
}
exports.default = FailedToDecryptConnectionKeyError;
//# sourceMappingURL=FailedToDecryptConnectionKeyError.js.map